import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { clientInfoHandlers, clientInfoInitialState, clientInfoReducer } from '../reducers/ClientInfoReducer';
import { PapsContext } from './PapsContext';
import { DatabaseContext } from './DatabaseContext';
import { _useCache, ServiceWorkerContext } from './ServiceWorkerContext';
import { _cacheNames, _cacheTypes } from '../reducers/ServiceWorkerReducer';
import { getNow } from '../../common/dateFormatting';
import { useClientInfo } from './useHelpers/useClientInfo';


/** gets the data for the uiItem.
 * @returns viewListData, confirmation */
export const ClientInfoContext = createContext();

/** gets the data for the uiItem.
 * @returns viewListData,  
 * @returns confirmation */
const ClientInfoProvider = (props) => {

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // serviceWorkerContext
  const serviceWorkerContext = useContext(ServiceWorkerContext)
  const { serviceWorker_state, serviceWorker_handlers } = serviceWorkerContext ?? {}
  const cache_data = serviceWorker_state?.cache_info?.cache_groups?.[_cacheNames.cache_client] ?? {};

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews, cacheKey } = paps_state ?? {}
  const { clients: clientKey } = pathViews ?? {}

  const { clientInfo, handleGet_eventsInfo } = useClientInfo()

  // clientInfoInitialState
  const initState = clientInfoInitialState({ database_fns, pathViews })
  const [clientInfo_state, dispatch] = useReducer(clientInfoReducer, initState);
  const { dataFromCache, clientsFetched, clientEvents } = clientInfo_state ?? {}

  // const clientInfo_handlers = useMemo(
  //   () => clientInfoHandlers(dispatch),
  //   [dispatch]
  // );

  const clientInfo_handlers = useMemo(() => {
    return {
      ...clientInfoHandlers(dispatch), // existing handlers
      handleGet_eventsInfo,          // add the function from your hook
    };
  }, [dispatch, handleGet_eventsInfo]);


  useEffect(
    () => {
      if (pathViews.clients) {
        clientInfo_handlers.handleInit_clientInfo(clientInfo)
      }
    },
    // eslint-disable-next-line
    [clientInfo, clientKey]
  )

  useEffect(() => {
    if (!_useCache.clients) { return }
    if (!dataFromCache) {
      // if clientEvents exist, send the data AND timestamps to the service worker.
      if (clientEvents) {
        const uivi = 'events'
        const _currentTimeStamp = getNow()
        const settings_data = {
          cacheKey: cacheKey,
          cacheName: uivi,
          cacheData: clientEvents
        }
        serviceWorker_handlers.handleSend_messageToServiceWorker(settings_data);

        // cache the TIME STAMP
        const settings_timeStamp = {
          cacheKey: cacheKey,
          cacheName: '_timeStamps',
          cacheData: { [uivi]: _currentTimeStamp, merge: true }
        }
        serviceWorker_handlers.handleSend_messageToServiceWorker(settings_timeStamp);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [clientsFetched, clientEvents]);

  const context = () => <ClientInfoContext.Provider value={{ clientInfo_state, clientInfo_handlers }}>
    {props.children}
  </ClientInfoContext.Provider>

  return context()
}

export default ClientInfoProvider